var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSave = function SvgSave(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2403 2.66675H4.00033C3.6467 2.66675 3.30756 2.80722 3.05752 3.05727C2.80747 3.30732 2.66699 3.64646 2.66699 4.00008V20.0001C2.66699 20.3537 2.80747 20.6928 3.05752 20.9429C3.30756 21.1929 3.6467 21.3334 4.00033 21.3334H20.0003C20.3539 21.3334 20.6931 21.1929 20.9431 20.9429C21.1932 20.6928 21.3337 20.3537 21.3337 20.0001V5.85341L18.2403 2.66675ZM16.667 20.0001H7.33366V14.6667H16.667V20.0001ZM20.0003 20.0001H18.0003V14.6667C18.0003 14.3131 17.8598 13.974 17.6098 13.7239C17.3598 13.4739 17.0206 13.3334 16.667 13.3334H7.33366C6.98004 13.3334 6.6409 13.4739 6.39085 13.7239C6.1408 13.974 6.00033 14.3131 6.00033 14.6667V20.0001H4.00033V4.00008H6.66699V8.00008C6.66699 8.3537 6.80747 8.69284 7.05752 8.94289C7.30757 9.19294 7.6467 9.33342 8.00033 9.33342H16.0003C16.3539 9.33342 16.6931 9.19294 16.9431 8.94289C17.1932 8.69284 17.3337 8.3537 17.3337 8.00008H8.00033V4.00008H17.6737L20.0003 6.39341V20.0001Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSave, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/save.f62e33ef.svg";
export { ForwardRef as ReactComponent };